import * as React from 'react';

import * as styles from './asideGroup.css';

export const AsideGroup = (props: React.PropsWithChildren<{}>) => {
  return <div className={styles['group']}>{props.children}</div>;
};
